import { useQuery } from '@tanstack/react-query';
import { unwrap } from '@billda/api';
import { useAuthStore } from '../../auth/stores/authStore';
import { api } from '../../../shared/api/billdaApi';
import { platformKeys } from './usePlatformOrganisations';

export function usePlatformOrganisation(orgId: string) {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);

  return useQuery({
    queryKey: platformKeys.organisation(orgId),
    queryFn: async ({ signal }) =>
      unwrap(
        await api.legacy.GET('/api/v1/platform/organisations/{orgId}', {
          params: { path: { orgId } },
          signal,
        })
      ),
    enabled: isAuthenticated && !!orgId,
  });
}
